import { Component, Input } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgFor, NgClass } from '@angular/common';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    standalone: true,
    imports: [NgFor, NgClass, ExtendedModule]
})
export class RatingComponent {
    @Input() value = 0;

    constructor() { }
}
